import { FunctionComponent } from "react";
import * as Styled from "./styles";

interface SpinnerProps {
  size: number;
  color: string;
}

const Spinner: FunctionComponent<SpinnerProps> = ({ size, color }: SpinnerProps) => {
  return (
    <Styled.SpinnerContainer $color={color} $size={size}>
      <span />
      <span />
      <span />
      <span />
    </Styled.SpinnerContainer>
  );
};

export default Spinner;
